import 'dayjs/locale/ja';
import './index.css';

import enJson from '_locales/en.json';
import jaJson from '_locales/ja.json';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import * as echarts from 'echarts/core';
import langJA from 'echarts/lib/i18n/langJA';
import i18n from 'i18next';
// import reportWebVitals from './reportWebVitals';
import {SnackbarProvider, useSnackbar} from 'notistack';
import ReactDOM from 'react-dom/client';
import {initReactI18next} from 'react-i18next';

import CancelIcon from '@mui/icons-material/Cancel';
import LFCIconButton from '_components/inputs/LFCIconButton';
import {LicenseInfo} from '@mui/x-license-pro';

import App from './App';
import {cleanupPwaArtifacts} from './_logics/pwaCleanup';

//x-data-grid-pro
LicenseInfo.setLicenseKey(
  '6d009b2d1bdf9421b5e8445bc086c8ebTz0xMTk3NTksRT0xNzk0NjE0Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
); //ラインセンス登録

//echarts
echarts.registerLocale('JA', langJA); //日本語辞書の登録

//dayjs
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat); //ローカライズされた形式を利用可能にする

//初期langはブラウザのlanguagesを取得
const blrLang = (
  (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language ||
  'en'
).slice(0, 2);

//i18n 初期設定
i18n.use(initReactI18next).init({
  resources: {ja: {translation: jaJson}, en: {translation: enJson}},
  lng: blrLang, //初期表示する言語
  // fallbackLng: "en", //選択した言語に関する辞書情報がない場合に、かわりに表示する言語
  // returnNull: false,
  // returnEmptyString: false,
  interpolation: {escapeValue: false}
  // react: {
  //   transKeepBasicHtmlNodesFor: ["wbr"],
  // },
});

const DismissAction = ({id}: any) => {
  const {closeSnackbar} = useSnackbar();
  return (
    <LFCIconButton color="inherit" size="small" onClick={() => closeSnackbar(id)}>
      <CancelIcon />
    </LFCIconButton>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <SnackbarProvider dense hideIconVariant maxSnack={10} action={key => <DismissAction id={key} />}>
    <App />
  </SnackbarProvider>
);

cleanupPwaArtifacts().catch(error => {
  console.warn('PWA cleanup failed:', error);
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
